import { Navigate, useParams } from "react-router-dom";
import TeamInvitation from "../public/TeamInvitation";

const VALID_ACTIONS = ["accept", "reject"];

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export default function TeamInvitationGuard() {
  const { loguuid, action } = useParams();

  if (!UUID_REGEX.test(loguuid || "") || !VALID_ACTIONS.includes(action)) {
    return <Navigate to="/404" replace />;
  }

  return <TeamInvitation />;
}
